import { Paragraph } from '@uncinc/react-drupal-core';
import type { ParagraphEntity, ReferenceField } from '@uncinc/react-drupal-core/types';
import classNames from 'classnames';
import Immutable from 'immutable';
import React from 'react';

declare interface ParagraphsRenderProps {
  paragraphs: ReferenceField<ParagraphEntity>[];
  className?: string;
  isLarge?: boolean;
}

interface ParagraphsExclude extends ParagraphsRenderProps {
  exclude?: string[];
  only?: never;
}
interface ParagraphsOnly extends ParagraphsRenderProps {
  exclude?: never;
  only?: string[];
}

const ParagraphsRenderer: React.FC<ParagraphsExclude | ParagraphsOnly> = ({
  paragraphs,
  className,
  exclude = [],
  only = [],
  isLarge = false,
}) => {
  const isImmutable = Immutable.isImmutable(paragraphs);
  const paragraphsArray = isImmutable ?
    (paragraphs.toJS() as ReferenceField<ParagraphEntity>[])
    : paragraphs;

  if (!paragraphsArray || !paragraphsArray.length) return null;

  const classes = classNames('Paragraphs', className);

  return (
    <div className={classes}>
      {paragraphsArray
        .map((paragraph) => {
          const id = paragraph.target_id;
          const language = paragraph.entity?.langcode[0]?.value;

          if (
            exclude.length &&
            exclude.find((p) => p === paragraph.entity.type[0].target_id)
          ) {
            return null;
          }

          if (
            only.length &&
            !only.find((p) => p === paragraph.entity.type[0].target_id)
          ) {
            return null;
          }

          return (
            <Paragraph
              key={`paragraph:${id}:${language}`}
              id={id}
              entity={Immutable.fromJS(paragraph.entity)}
              isLarge={isLarge}
            />
          );
        })}
    </div>
  );
};

export default ParagraphsRenderer;
